import React from 'react'

type ProgressBarProps = {
  value: number
  max?: number
  className?: string
}

export const ProgressBar = ({ value, max = 5, className = '' }: ProgressBarProps): JSX.Element => {
  const percentage = Math.min((value / max) * 100, 100)

  return (
    <div className={`w-full bg-gray-200 rounded-full h-2.5 ${className}`}>
      <div
        className="bg-orange h-2.5 rounded-full transition-all duration-300"
        style={{ width: `${percentage}%` }}
      ></div>
    </div>
  )
}
